
import { getVideos, stripHTML, whenAvailable } from './../api';
import Loader from './../Loader.vue';
import loadjs from 'loadjs';
import Category from './Category.vue';

export default {

    components: {
        "loader": Loader,
        "category": Category,
    },

    props: {
        categoryid: {
            type: String
        },
        pagetitle: {
            type: String
        }
    },

    data() {
        return {
            category: [],
            swiper: null,
            activeIndex: 0,
        }
    },

    methods: {
        async loadVideos()  {
            this.category = await getVideos();
            this.loadSwiper();
        },
        loadSwiper()  {
            var self = this;
            whenAvailable("Swiper", function(){
                var initialSlide = 0;
                if(self.categoryid) {
                    for (var index = 0; index < self.category.length; index++) {
                        if(self.category[index].Id == self.categoryid) {
                            initialSlide = index;
                        }
                    }
                }
                self.swiper = new Swiper(self.$refs.swiper, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    slideActiveClass: "swiper-slide-active--main",
                    initialSlide: initialSlide,
                    history: {
                        enabled: true,
                        key: "",
                        root: "/videos/",
                    },
                    on: {
                        init: function(){
                            self.playActiveVideo(this);
                        },
                        slideChange: function() {
                            self.playActiveVideo(this);
                            self.activeIndex = this.realIndex;
                        }
                    }
                });
            });
        },

        selectSlide(slideIndex) {
            this.swiper.slideToLoop(slideIndex);
        },

        playActiveVideo(swiper) {
            var self = this;
            loadjs.ready('videojs', function(){
                for (var index in videojs.players) {
                    if (Object.hasOwnProperty.call(videojs.players, index)) {
                        try {
                            videojs.players[index].pause();
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }
                var slide = swiper.slides [ swiper.activeIndex ];
                var $videos = $(slide).find('video');
                if($videos.length > 0) {
                    if($videos[0].currentTime < 22) {
                        $videos[0].currentTime = 22;
                    }
                    $videos[0].play();
                }
            });
        },

        prev() {
            var $innerSwiper = $('.swiper-slide-active--main .swiper');
            if($innerSwiper.length > 0) {
                var innerSwiper = $innerSwiper[0].swiper;
                if(!innerSwiper.slidePrev()) {
                    this.swiper.slidePrev();
                }
            } else {
                this.swiper.slidePrev();
            }
        },

        next() {
            var $innerSwiper = $('.swiper-slide-active--main .swiper');
            if($innerSwiper.length > 0) {
                var innerSwiper = $innerSwiper[0].swiper;
                if(!innerSwiper.slideNext()) {
                    this.swiper.slideNext();
                }
            } else {
                this.swiper.slideNext();
            }
        },

        unescape(html) {
            const div = document.createElement('div');
            div.innerHTML = html;
            return div.textContent || div.innerText;
        }
    },

    created() {
        this.loadVideos();
    },

    mounted() {
        document.title = stripHTML(this.pagetitle);
    }
}

